app.controller('changePasswordCtrl', ['$scope', '$routeParams', '$window', '$q', 'appFactory',
    function ($scope, $routeParams, $window, $q, appFactory) {

    $scope.User = {};
    $scope.User.GeneratedKey = $routeParams.generatedkey;

    // confirm password harus sama
    $scope.ConfirmPassword = '';
    $scope.checkPassword = function () {
        if ($scope.ConfirmPassword != $scope.User.NewPassword) {
            $scope.formChange.txtConfirmPassword.$invalid = true;
        } else {
            $scope.formChange.txtConfirmPassword.$invalid = false;
        }
    };

    // get params, jika genkey salah maka kembali ke halaman awal / login
    if ($routeParams.generatedkey) {

        appFactory.getData(`service/client.svc/GetChangePasswordKey?key=${$scope.User.GeneratedKey}`).then(function (data) {

            if (data.status == 200) {
                if (!data.data.d.result) {

                    $window.location.href = "/#/";
                    return;
                }

                $scope.User.Email = data.data.d.email;
            }
        });
    }

    var allPromise = $q.all([]);

    $scope.submit = function () {

        // dynamic sweet alert post to app.js
        // 1: set the url of post or get request
        // 2: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 3: set the postdata to $http request = GET : {} / POST { yourdata : data }
        // 4: set the method to $http request = "GET" / "POST"
        // 5: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 6: if success or no error returns then...
        var urlsvc = 'service/client.svc/changePassword'; // 1
        var preconfirmtranslate = "changepasswordconf"; // 2
        var postData = { chgPass: $scope.User } // 3
        var method = "POST" // 4
        $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

            if (issuccess) // 6
                $window.location.href = "#/login"; 
        });
    };
}]);